import { getPermissions, handleSaleRepLogin, setPageTitle } from "@/helpers/Helpers";
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/NewDashboard')
const NotFound = () => import('@/views/pages/Page404')
const Login = () => import('@/views/pages/Login')
const Forbidden = () => import('@/views/pages/Forbidden')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')

const ResetPassword = () => import('@/views/pages/ResetPassword')

const Register = () => import('@/views/pages/Register')
const Products = () => import('@/views/products/Listing')
const AddProduct = () => import('@/views/products/Add')
const EditCompanyProduct = () => import('@/views/products/EditCompanyProduct')
const Factories = () => import('@/views/factories/Listing')
const sku = () => import('@/views/sku/Listing')
const EmailTemplate = () => import('@/views/email-templates/Listing')
const Steps = () => import('@/views/steps/Listing')
const Categories = () => import('@/views/categories/Listing')
const DataSource = () => import('@/views/datasource/Listing')
const Permissions = () => import('@/views/authorization/permissions')
const Roles = () => import('@/views/authorization/roles')
const User = () => import('@/views/authorization/user')
const Settings = () => import('@/views/authorization/assignpermissions')

const EmailConfiguration = () => import('@/views/settings/EmailConfiguration')
const GeneralSettings = () => import('@/views/settings/GeneralSettings')
const UIBranding = () => import('@/views/settings/UIBranding')
const Container = () => import('@/views/container/Listing');
const Sizes = () => import('@/views/products/Sizes');
const ViewProductDesign = () => import('@/views/container/ViewProductDesign')
const Customers = () => import('@/views/authorization/customers')
const Cuttings = () => import('@/views/cuttings/Listing')
const OrderListing = () => import('@/views/order/OrderListing')
const OrderView = () => import('@/views/order/view')
const OrderDetail = () => import('@/views/order/OrderDetail')
const CondensendPdfView = () => import('@/views/order/CondensendPdfView')

const YearlyPlannerTemplates = () => import('@/views/yearly-planner-templates/Listing')
const YearlyPlannerEvents = () => import('@/views/yearly-planner-events/Listing')
const Translations = () => import('@/views/translations/Listing');
const Companies = () => import('@/views/companies');
const GeneralAction = () => import('@/views/GeneralAction.vue');

const EditTechpak = () => import('@/views/order/CondensendPdfEdit.vue');

const PriceList = () => import('@/views/price-list/Listing.vue')
const DesignCategories = () => import('@/views/design-categories/Listing.vue')
const DefaultProducts = () => import('@/views/default-products')
const EditDefaultProducts = () => import('@/views/default-products/Edit.vue')


Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
});


function configRoutes() {
  return [
    {
      path: '/order/:order_id/condensend-pdf',
      component: CondensendPdfView
    },
    //todo need to remove this after confirmation, as redirection applied here while the component is also introduced
    {
      path: '/',
      redirect: { name: 'Dashboard' },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/login',
      redirect: '/login',
      name: 'Home',
      component: Login,
      children: [
        {
          path: '/login',
          name: 'Login',
        }
      ]
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'products',
          name: 'products',
          component: Products
        },
        {
          path: 'products/add',
          name: 'add-product',
          component: AddProduct
        },
        {
          path: 'products/update/:id',
          name: 'edit-product',
          component: AddProduct
        },
        {
          path: 'products/update-company-fields/:id',
          name: 'edit-company-product',
          component: EditCompanyProduct,
          props: true
        },
        {
          path: 'products/steps',
          name: 'add-steps',
          component: Steps
        },
        {
          path: 'products/categories',
          name: 'categories',
          component: Categories
        },
        {
          path: 'products/data-source',
          name: 'data-source',
          component: DataSource
        },
        {
          path: 'container',
          name: 'container',
          component: Container
        },
        {
          path: 'product-designs/:id/view',
          name: 'ViewProductDesign',
          component: ViewProductDesign
        },
        {
          path: 'roaster-sizes',
          name: 'roaster-sizes',
          component: Sizes
        },
        {
          path: 'factory-cuttings',
          name: 'factory-cuttings',
          component: Cuttings
        },
        {
          path: 'translations',
          name: 'translations',
          component: Translations
        },
        {
          path: 'price-list',
          name: 'price-list',
          component: PriceList
        },
        {
          path: 'design-categories',
          name: 'design-categories',
          component: DesignCategories
        },

//Frobidden Route
        {
          path: '/unauthorized',
          name: 'Unauthorized',
          component: Forbidden,
        },
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'factories',
          name: 'factories',
          component: Factories
        },
        {
          path: 'sku',
          name: 'sku',
          component: sku
        },
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'email-configuration',
          name: 'email-configuration',
          component: EmailConfiguration
        },
        {
          path: 'general-settings',
          name: 'general-settings',
          component: GeneralSettings
        },
        {
          path: 'ui-branding',
          name: 'ui-branding',
          component: UIBranding
        },
        {
          path: 'email-templates',
          name: 'email-templates',
          component: EmailTemplate
        },
        {
          path: 'yearly-planner-events/:id/view',
          name: 'YearlyPlannerEvents',
          component: YearlyPlannerEvents,
          props: { templateName: 'sdfa' }
        },
        {
          path: 'yearly-planner-templates',
          name: 'YearlyPlannerTemplates',
          component: YearlyPlannerTemplates
        }

      ]
    },
    {
      path: '/edit-techpack/:order_id',
      name: 'EditTechpak',
      component: EditTechpak
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'permissions',
          name: 'permissions',
          component: Permissions
        },
        {
          path: 'roles',
          name: 'roles',
          component: Roles
        },
        {
          path: 'users',
          name: 'users',
          component: User
        },
        {
          path: 'role/permissions/:id/update',
          name: 'assignpermissions',
          component: Settings
        },
        {
          path: 'customers',
          name: 'customers',
          component: Customers
        },
        {
          path: 'orders',
          name: 'orders',
          component: OrderListing
        },
        {
          path: '/order/:order_id/detail',
          name: 'OrderDetail',
          component: OrderDetail
        },
        {
          path: 'order/:order_item_id/:factory_product_id',
          name: 'order-view',
          component: OrderView
        },
        {
          path: 'companies',
          name: 'companies',
          component: Companies
        },
        {
          path: 'general-action',
          name: 'general-action',
          component: GeneralAction
        },
        {
          path: 'default-products',
          name: 'default-products',
          component: DefaultProducts
        },
        {
          path: 'products/update-default-product/:id',
          name: 'edit-default-products',
          component: EditDefaultProducts,
          props: true
        },
      ]
    },
    {
      path: '/*',
      redirect: '/dashboard',
    },
    {
      path: '/error',
      name: 'notfound',
      component: NotFound
    },

  ]
}

router.beforeEach(async (to, from, next) => {
  const returnUrl = from.query.source; 
  setPageTitle()
  if (returnUrl && returnUrl === "new_dashboard" &&  to.name == 'Dashboard') { 
    window.location.href = process.env.VUE_APP_NEW_URL; 
  } 

  const authToken = to.query.auth_token;
  // redirect unauthenticated user to login page if trying to access a restricted page
  const publicPages = ['/login', '/forgot-password', '/reset-password'];
  const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('access_token');
  if (authRequired && !store.getters.isAuthenticated) {
    if (authToken) {
      const { auth_token, ...restOfQuery } = to.query;
      const queryString = new URLSearchParams(restOfQuery).toString();
      const redirect_url = `${window.location.origin}${to.path}${queryString ? `?${queryString}` : ''}`;
      handleSaleRepLogin(to.params.order_id, authToken, redirect_url)
    } else {
      return next({
        path: '/login',
      });
    }

  } else {
    if (store.getters.isAuthenticated) {
      if (authToken) {
        const { auth_token, ...restOfQuery } = to.query;
        const queryString = new URLSearchParams(restOfQuery).toString();
        const redirect_url = `${window.location.origin}${to.path}${queryString ? `?${queryString}` : ''}`;
        handleSaleRepLogin(to.params.order_id, authToken, redirect_url)
      } else {
        await getPermissions()
      }

    }
    if (!authToken) {
      if (to.path === '/login' && store.getters.isAuthenticated) {
        if (to.query.redirect === 'products') {
          return next({
            path: '/products', query: { 'sync': to.query.sync, 'post_id': to.query.post_id }
          });
        } else {
          return next({ name: 'Dashboard' })
        }
      } else if (to.path === '/general-action' && store.getters.roleName !== 'superadmin') { // only superadmin can access general-action
        return next({ name: 'Dashboard' })
      }
      next();
    }
  }
})

export default router;
